module.exports = "<div class=\"ssf-brand row\">\n    <div class=\"col-4\">\n        <ssf-logo class=\"ssf-brand__logo\" [logo]=\"logo\" [logoAlt]=\"logoAlt\"></ssf-logo>\n    </div>\n    <div class=\"col-8 ssf-brand__info\">\n        <div class=\"ssf-brand__name ssf-brand__name_shortened\">\n            {{name}}\n        </div>\n        <div class=\"ssf-brand__name ssf-brand__name_full\" *ngIf=\"description\">\n            {{description}}\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/brand-identifier/brand-identifier.component.html
// module id = 647
// module chunks = 3